module.exports = __webpack_public_path__ + "img/m_contents_taxi@2x.0485a10e.png";